// Base Report
import * as React from "react"
import makeStyles from "@material-ui/core/styles/makeStyles"
import {Box} from "@material-ui/core"
import {findFilters, ReportRouteProps} from "../reports/common/components/ReportsPage"
import {ReportFilters} from "../reports/common/models/ReportFilters"
import {reportsStore} from "../reports/common/stores/ReportStore"
import {useEffect, useRef, useState} from "react"
import {ReportStructure, ReportStructuresMap} from "./ReportStructures"
import {ReportProps} from "./ReportData"
import {groupMasterStore} from "../common/group/GroupMasterStore"
import {observer} from "mobx-react-lite"
import {loadingSpinnerStore} from "../common/loaders/LoadingSpinnerStore"
import {PrintOptions} from "../reports/common/components/PrintViewContainer"


const useReportPageStyle = makeStyles(theme => ({
   root: {
      // TODO: Remove the below value when we remove the link to classic reports
      // marginTop: 50,
   },
   titleContainer: {
      paddingBottom: theme.spacing(2),
      display: "flex",
      flexGrow: 1,
   },
   titleControlContainer: {
      display: "flex",
      marginLeft: "auto",
      justifyContent: "flex-start"
   },
   searchComponentContainer: {
      paddingBottom: theme.spacing(2),
   },
   testInstanceListContainerTextOnly: {
      minHeight: 480,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
   },
   printAndDownloadButtons: {
      marginLeft: theme.spacing(2)
   }
}))

const ReportContainer = observer((props: ReportRouteProps) => {
    const [reportStructure, setReportStucture] = useState<ReportStructure>()
    const filters: ReportFilters = findFilters(props)
    const prevProps = useRef(filters)

    useEffect(() => {
        if (!reportStructure) {
            loadingSpinnerStore.hideLoadingSpinner = false
            reportsStore.reportTableData = undefined
            reportsStore.reportGraphData = undefined

            const reportStruct: ReportStructure | undefined = ReportStructuresMap.get(filters.productId)

            if (reportStruct && reportStruct.data) {
                reportStruct.data(filters)
            }

            setReportStucture(reportStruct)
            prevProps.current = filters
        }

        const fils: ReportFilters = findFilters(props)
        if (JSON.stringify(prevProps.current) != JSON.stringify(fils)) {
            loadingSpinnerStore.hideLoadingSpinner = false
            reportStructure!.data!(fils)
        }

    }, [props, reportStructure])

    if (!filters || !reportStructure) return <></>

    return <Report reportStructure={reportStructure} filters={filters} />
})

export const Report = observer(({reportStructure, filters, printOptions}: { reportStructure: ReportStructure, filters: ReportFilters, printOptions?: PrintOptions}) => {
    const classes = useReportPageStyle()
    const {Header, SummaryCharts, TestControls, TestInstancesList} = reportStructure
    const reportProps: ReportProps = {
        groupInfo: groupMasterStore.groupInfo,
        printOptions: printOptions,
        filters: filters,
        graphData: reportsStore.reportGraphData,
        tableData: reportsStore.reportTableData,
        skillColumns: reportStructure.TestInstancesListColumns!,
    }

    // Waiting for the follow data to be available
    if (
        (SummaryCharts && typeof reportProps.graphData == "undefined") ||
        typeof reportProps.tableData == "undefined" ||
        !reportProps.groupInfo
    ) {
        return <></>
    }

    loadingSpinnerStore.hideLoadingSpinner = true

    return (
        <Box className={classes.root}>
            <Header {...reportProps} />
            {SummaryCharts && <SummaryCharts {...reportProps} />}
            {TestControls && <TestControls {...reportProps} />}
            {TestInstancesList && <TestInstancesList {...reportProps} />}
        </Box>
    )
})

export default ReportContainer
